var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5705 45.9392C10.6305 46.1857 10.7392 46.4176 10.8904 46.6214C11.0415 46.8251 11.2319 46.9965 11.4504 47.1254C11.6689 47.2543 11.911 47.3381 12.1624 47.3719C12.4138 47.4057 12.6695 47.3887 12.9142 47.322C24.0868 44.2284 35.89 44.2284 47.0627 47.322C47.3074 47.3887 47.5631 47.4057 47.8145 47.3719C48.0659 47.3381 48.308 47.2543 48.5265 47.1254C48.745 46.9965 48.9354 46.8251 49.0865 46.6214C49.2377 46.4176 49.3464 46.1857 49.4064 45.9392L55.383 20.5564C55.465 20.2166 55.4505 19.8607 55.341 19.5288C55.2315 19.1969 55.0314 18.9021 54.7633 18.6779C54.4952 18.4537 54.1697 18.3088 53.8237 18.2598C53.4776 18.2107 53.1247 18.2593 52.8049 18.4001L40.9455 23.6736C40.5158 23.8628 40.0312 23.886 39.5854 23.7389C39.1395 23.5917 38.764 23.2845 38.5314 22.8767L31.6408 10.4548C31.4786 10.1618 31.241 9.91747 30.9524 9.74737C30.6639 9.57726 30.3351 9.48755 30.0002 9.48755C29.6652 9.48755 29.3364 9.57726 29.0479 9.74737C28.7594 9.91747 28.5217 10.1618 28.3595 10.4548L21.4689 22.8767C21.2363 23.2845 20.8608 23.5917 20.415 23.7389C19.9691 23.886 19.4845 23.8628 19.0549 23.6736L7.19548 18.4001C6.87559 18.2593 6.5227 18.2107 6.17664 18.2598C5.83058 18.3088 5.50513 18.4537 5.23703 18.6779C4.96892 18.9021 4.76882 19.1969 4.65933 19.5288C4.54983 19.8607 4.53529 20.2166 4.61735 20.5564L10.5705 45.9392Z",
    fill: "#666B70",
    fillOpacity: 0.2,
    stroke: "#666B70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 37.895C27.4855 37.356 32.5145 37.356 37.5 37.895",
    stroke: "#666B70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.7e640fca.svg";
export { ForwardRef as ReactComponent };